import styled from 'styled-components';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
export const GridListAction = styled(LayoutHorizontal).withConfig({
  displayName: "GridListAction",
  componentId: "sc-47up9m-0"
})(["flex:0 0 auto;opacity:", ";transition:opacity 0.2s ease-in-out;.can-select-disabled &{visibility:hidden;opacity:0;}.can-select:hover &,.can-select:focus &,.can-select:focus-visible &,.can-select:focus-within &{opacity:1;}"], ({
  isVisible
}) => isVisible ? '1' : '0');